import Link from 'next/link';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';

import { postReq } from 'api';
import Button from 'components/Button';
import Input from 'components/Input';
import { EmailRegEx } from 'data/globalConstants';

import { forgot_password, validation } from 'lang/en.json';
import LoginLayout from 'layouts/LoginLayout';
import styles from 'styles/modules/Login.module.scss';
import SEO from 'next-seo.config';
import { NextSeo } from 'next-seo';
import { authSelector } from 'store/auth';

function ForgotPassword() {
    const { register, handleSubmit, errors } = useForm();
    const router = useRouter();
    const { isAuthenticated, company } = useSelector(authSelector);
    const [visibleMessage, setVisibleMessage] = useState(false);
    const [resetSuccess, setResetSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isAuthenticated && company) {
            router.replace(`/${company}`);
        }
    }, [isAuthenticated, company]);

    const onSubmit = async (data) => {
        setLoading(true);
        try {
            const res = await postReq(`/auth/forgot`, data);
            if (res.status === 201) {
                setResetSuccess(true);
                setVisibleMessage(true);
                return setLoading(false);
            }
            setVisibleMessage(true);
            setResetSuccess(false);
            setLoading(false);
        } catch (err) {
            setVisibleMessage(true);
            setResetSuccess(false);
            setLoading(false);
        }
    };

    return (
        <>
            <NextSeo
                {...SEO}
                titleTemplate={`Forgot Password | %s`}
                noindex
                nofollow
            />
            <LoginLayout>
                <form onSubmit={handleSubmit(onSubmit)}>
                    {/* HEADER */}
                    <header className={styles.header}>
                        {visibleMessage && (
                            <div
                                className={[
                                    styles.errorBox,
                                    resetSuccess ? styles.successBox : '',
                                ].join(' ')}
                            >
                                {resetSuccess
                                    ? forgot_password.success
                                    : forgot_password.error}
                            </div>
                        )}
                        <h1 className={styles.title}>
                            {forgot_password.title}
                        </h1>
                        <p className={styles.copy}>{forgot_password.body}</p>
                    </header>

                    {/* INPUTS */}
                    <div className={styles.inputWrapper}>
                        <Input
                            type={'email'}
                            label={'E-mail'}
                            name={'email'}
                            color={'blue'}
                            error={errors['email']}
                            register={register({
                                required: validation.required,
                                value: {
                                    pattern: EmailRegEx,
                                    message: validation.email,
                                },
                            })}
                        />
                    </div>

                    <div className={[styles.linksWrapper].join(' ')}>
                        <div className={styles.col}>
                            <Link href={'/login'}>
                                <a>{forgot_password.back}</a>
                            </Link>
                        </div>
                    </div>

                    {/* BUTTON */}
                    <Button
                        title={forgot_password.button}
                        theme={'primary'}
                        type={'submit'}
                        loading={loading}
                    />
                </form>
            </LoginLayout>
        </>
    );
}

export default ForgotPassword;
